// NL / EN translations for Feenstra Designs

export const translations = {
  nl: {
    nav: {
      home: "Home",
      about: "Over Mij",
      portfolio: "Portfolio",
      contact: "Contact",
    },
    hero: {
      eyebrow: "Architectural Visualisation Studio",
      title1: "Feenstra",
      title2: "Designs",
      subtitle: "Architectural Visualisation & Design",
      description:
        "Minimalistische en hoogwaardige visualisaties voor woningen, interieurs en leefomgevingen.",
      ctaProjects: "Bekijk Projecten",
      ctaContact: "Neem Contact Op",
      scroll: "Scroll",
    },
    projects: {
      eyebrow: "Geselecteerd Werk",
      title: "Featured Projects",
      description:
        "Een selectie van recente visualisaties — van woningbouw tot publieke ruimtes.",
    },
    portfolio: {
      eyebrow: "Ons Werk",
      title: "Portfolio",
      subtitle:
        "Een overzicht van geselecteerd werk, georganiseerd per discipline. Klik op een project om alle visualisaties te bekijken.",
      countLabel: "projecten",
      cta: "Vraag een visualisatie aan",
      filterAria: "Filter portfolio op categorie",
      viewProject: "Bekijk project",
      imageCount: "afbeeldingen",
      imageCountSingle: "afbeelding",
      empty: "Geen projecten gevonden in deze categorie.",
    },
    process: {
      eyebrow: "Werkwijze",
      title: "Van idee tot werkelijkheid",
      steps: [
        {
          n: "01",
          title: "Concept",
          body: "We vertalen jouw visie naar een helder ruimtelijk concept. Schetsen, referenties en architectonische intenties vormen het fundament.",
        },
        {
          n: "02",
          title: "Visualisatie",
          body: "Met fotorealistische renders breng ik het ontwerp tot leven — licht, materiaal en sfeer in perfecte balans.",
        },
        {
          n: "03",
          title: "Realisatie",
          body: "Begeleiding tot aan de uiteindelijke uitvoering, zodat het beeld en de bouw naadloos in elkaar overgaan.",
        },
      ],
    },
    quote: {
      text: "Sterke architectuur begint bij het visualiseren van een idee.",
      author: "— Jesse Feenstra",
    },
    about: {
      eyebrow: "Over Mij",
      title: "Over Mij",
      subtitle: "Passie voor architectuur en ruimtelijke beleving.",
      bodyParagraphs: [
        "Feenstra Designs is opgericht door Jesse Feenstra, een gedreven ontwerper met een levenslange passie voor architectuur. Al van jongs af aan stond zijn ambitie vast: architect worden. Waar andere kinderen speelden, bouwde hij urenlang huizen, steden en constructies met LEGO. Daar werd het fundament gelegd voor een fascinatie voor vormgeving, ruimte en architectuur — een passie die hem nooit meer heeft losgelaten.",
        "Na jaren van opleidingen, studies en praktijkervaring is die droom realiteit geworden. Vandaag de dag staat hij aan het roer van een eigen visualisatiebureau, waar dagelijks met toewijding wordt gewerkt aan het ontwerpen van inspirerende en doordachte ruimtes.",
        "De expertise van Feenstra Designs reikt verder dan woningen en interieurs alleen. Ook natuurlijke omgevingen, publieke ruimtes en gebieden waar mensen samenkomen, beleven en tot rust komen, behoren tot het werkterrein. Architectuur draait voor het bureau niet uitsluitend om gebouwen, maar om het vormgeven van complete leefomgevingen waarin esthetiek, functionaliteit en beleving samenkomen.",
        "Bij ieder ontwerp wordt gestreefd naar ruimtes die niet alleen visueel sterk zijn, maar bovenal een verhaal vertellen en een blijvende indruk achterlaten.",
      ],
      skillsTitle: "Expertise",
      skills: [
        "Architectural Visualisation",
        "Exterior Design",
        "Interior Concepts",
        "Urban & Public Spaces",
        "Sustainable Design",
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Laten we bouwen aan jouw idee",
      subtitle:
        "Heeft u een project in gedachten? Stuur een bericht — een reactie volgt doorgaans binnen 24 uur.",
      info: {
        emailLabel: "E-mail",
        phoneLabel: "Telefoon",
        socialLabel: "Volg",
      },
      form: {
        name: "Naam",
        email: "E-mail",
        message: "Bericht",
        submit: "Verzenden",
        sending: "Versturen…",
        successTitle: "Bericht verzonden",
        successBody: "Bedankt voor je bericht. Ik neem zo snel mogelijk contact met je op.",
        errorTitle: "Er ging iets mis",
        errorBody: "Probeer het opnieuw of stuur direct een e-mail.",
        validation: "Vul alle velden correct in.",
      },
    },
    footer: {
      tagline: "Architectural Visualisation & Design",
      rights: "Alle rechten voorbehouden.",
      links: {
        home: "Home",
        about: "Over Mij",
        portfolio: "Portfolio",
        contact: "Contact",
      },
    },
  },

  en: {
    nav: {
      home: "Home",
      about: "About",
      portfolio: "Portfolio",
      contact: "Contact",
    },
    hero: {
      eyebrow: "Architectural Visualisation Studio",
      title1: "Feenstra",
      title2: "Designs",
      subtitle: "Architectural Visualisation & Design",
      description:
        "Minimalist, high-end visualisations for homes, interiors and living environments.",
      ctaProjects: "View Projects",
      ctaContact: "Get in Touch",
      scroll: "Scroll",
    },
    projects: {
      eyebrow: "Selected Work",
      title: "Featured Projects",
      description:
        "A selection of recent visualisations — from residential to public spaces.",
    },
    portfolio: {
      eyebrow: "Our Work",
      title: "Portfolio",
      subtitle:
        "An overview of selected work, organised by discipline. Click a project to view all visualisations.",
      countLabel: "projects",
      cta: "Request a visualisation",
      filterAria: "Filter portfolio by category",
      viewProject: "View project",
      imageCount: "images",
      imageCountSingle: "image",
      empty: "No projects found in this category.",
    },
    process: {
      eyebrow: "Process",
      title: "From idea to reality",
      steps: [
        {
          n: "01",
          title: "Concept",
          body: "We translate your vision into a clear spatial concept — sketches, references and architectural intent form the foundation.",
        },
        {
          n: "02",
          title: "Visualisation",
          body: "Photo-realistic renders bring the design to life — light, materials and atmosphere in perfect balance.",
        },
        {
          n: "03",
          title: "Realisation",
          body: "Guidance through to the final build, so the rendered image and the construction align seamlessly.",
        },
      ],
    },
    quote: {
      text: "Strong architecture begins with visualising an idea.",
      author: "— Jesse Feenstra",
    },
    about: {
      eyebrow: "About Me",
      title: "About Me",
      subtitle: "A passion for architecture and spatial experience.",
      bodyParagraphs: [
        "Feenstra Designs was founded by Jesse Feenstra, a driven designer with a lifelong passion for architecture. From a young age, his ambition was clear: to become an architect. While other children played, he spent hours building houses, cities and structures with LEGO. That is where the foundation was laid for a fascination with form, space and architecture — a passion that has never let go.",
        "Years of education, studies and hands-on practice turned that dream into reality. Today, he leads his own visualisation studio, where every day is dedicated to designing inspiring and considered spaces.",
        "The expertise of Feenstra Designs extends beyond homes and interiors. Natural environments, public spaces and areas where people gather, experience and find calm are equally part of the practice. Architecture is not solely about buildings — it is about shaping complete living environments where aesthetics, function and experience come together.",
        "Every design strives for spaces that are not only visually compelling, but above all tell a story and leave a lasting impression.",
      ],
      skillsTitle: "Expertise",
      skills: [
        "Architectural Visualisation",
        "Exterior Design",
        "Interior Concepts",
        "Urban & Public Spaces",
        "Sustainable Design",
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's build your idea",
      subtitle:
        "Have a project in mind? Send a message — a reply usually follows within 24 hours.",
      info: {
        emailLabel: "Email",
        phoneLabel: "Phone",
        socialLabel: "Follow",
      },
      form: {
        name: "Name",
        email: "Email",
        message: "Message",
        submit: "Send",
        sending: "Sending…",
        successTitle: "Message sent",
        successBody: "Thanks for your message. I'll get back to you as soon as possible.",
        errorTitle: "Something went wrong",
        errorBody: "Please try again or email me directly.",
        validation: "Please fill in every field correctly.",
      },
    },
    footer: {
      tagline: "Architectural Visualisation & Design",
      rights: "All rights reserved.",
      links: {
        home: "Home",
        about: "About",
        portfolio: "Portfolio",
        contact: "Contact",
      },
    },
  },
};

export const CONTACT = {
  email: "fd.feenstra.designs@gmail.com",
  phone: "+31 6 34106207",
  phoneRaw: "+31634106207",
  instagram: "https://instagram.com/feenstradesigns",
  pinterest: "https://pin.it/31aobE0AX",
};

export const COOKIE = {
  nl: {
    title: "Privacy & Cookies",
    body: "Deze website gebruikt uitsluitend functionele cookies om de gebruikerservaring te verbeteren. Door verder te bladeren wordt akkoord gegaan met deze instellingen, conform de AVG/GDPR.",
    accept: "Akkoord",
    decline: "Weigeren",
  },
  en: {
    title: "Privacy & Cookies",
    body: "This website uses functional cookies only to improve your experience. By continuing to browse you agree to these settings, in accordance with GDPR.",
    accept: "Accept",
    decline: "Decline",
  },
};
